module.exports = "<app-circles></app-circles>\n<app-pie></app-pie>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1